// Utils
import { getMetaVersionId } from '../../common/elements/utils/elementPropertyUtils';
import { createNextVersionId } from '../../common/elements/utils/elementVersionUtils';
import { getSessionId } from '../device/deviceSessionService';

// Selectors
import { getElement } from '../element/selectors/elementSelector';

export type ElementUpdateVersionMeta = {
    modifiedVersionId: string | undefined;
    versionId: string;
};

/**
 * The version pair a versioned element update must carry: the stored version it was based on and
 * the next version for this client session. Callable from any process that holds the element state.
 */
export const getElementUpdateVersionMeta = (state: unknown, elementId: string): ElementUpdateVersionMeta => {
    const element = getElement(state, { elementId });
    const modifiedVersionId = getMetaVersionId(element);

    const sessionId = getSessionId();
    const versionId = createNextVersionId(sessionId, modifiedVersionId);

    return { modifiedVersionId, versionId };
};
